import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import InputGroupV2 from '../InputGroupV2';

const PerfilSelectV2 = ({ label, onChange, value, placement, title, useTooltip, isRequired, error, helperText, disabled }) => {
  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={isRequired}
    >
      <TextField
        error={error}
        helperText={error ? helperText : ''}
        fullWidth
        name={label.toLowerCase()}
        onChange={event => onChange(event.target.value)}
        select
        disabled={disabled}
        SelectProps={{ native: true }}
        value={value}
      >
        <option key="ROLE_ADMIN" value="ROLE_ADMIN">Administrador</option>
        <option key="ROLE_USUARIO" value="ROLE_USUARIO">Usuário</option>
      </TextField>
    </InputGroupV2>
  );
};

PerfilSelectV2.propTypes = {
  error: PropTypes.any,
  helperText: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  isRequired: PropTypes.any,
  disabled: PropTypes.bool,
};

PerfilSelectV2.defaultProps = {
  error: null,
  helperText: null,
  title: '',
  placement: 'top',
  isRequired: false,
  useTooltip: false,
  value: '',
  disabled: false,
};

export default PerfilSelectV2;
